import { render } from "./categoryOverviewTeaserWrapper.vue?vue&type=template&id=bd1ed490"
import script from "./categoryOverviewTeaserWrapper.vue?vue&type=script&lang=js"
export * from "./categoryOverviewTeaserWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__